import React from 'react'

import './index.css'

const Kite = () => {
  return (
    <div className="kite">
      <div className="tail" />
      <div className="string" />
    </div>
  )
}

export default Kite
